<template>
  <el-dropdown @command="handleLanguage" style="cursor: pointer">
    <span class="el-dropdown-link">
      <em class="fas fa-globe" />
      {{ labels[language] }}
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="tr"> Türkçe </el-dropdown-item>
      <el-dropdown-item command="en"> English </el-dropdown-item>
      <el-dropdown-item command="de"> Deutsch </el-dropdown-item>
      <el-dropdown-item command="ru"> русский </el-dropdown-item>
      <el-dropdown-item command="zh-tw"> 简体中文 </el-dropdown-item>
      <el-dropdown-item command="zh"> 繁體中文 </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import langTR from "element-ui/lib/locale/lang/tr-TR";
import langEN from "element-ui/lib/locale/lang/en";
import langRU from "element-ui/lib/locale/lang/ru-RU";
import langZHTW from "element-ui/lib/locale/lang/zh-TW";
import langZHCH from "element-ui/lib/locale/lang/zh-CN";
import langDE from "element-ui/lib/locale/lang/de";
import elLocale from "element-ui/lib/locale";
import axios from "axios";

import dayjs from "dayjs";
import  "dayjs/locale/en"
import  "dayjs/locale/de"
import  "dayjs/locale/tr"
import  "dayjs/locale/ru"
import  "dayjs/locale/zh-tw"
import  "dayjs/locale/zh"


export default {
  name: "language",
  data() {
    return {
      labels: {
        tr: "Türkçe",
        en: "English",
        de: "Deutsch",
        ru: "русский",
        "zh-tw": "简体中文",
        zh: "繁體中文",
      },
      model: {
        email: "",
        password: "",
      },
      rules: {},
    };
  },
  created() {},
  computed: {
    language: {
      get() {
        return this.$i18n.locale;
      },
    },
  },
  methods: {
    handleLanguage(command) {
      this.$i18n.locale = command;
      localStorage.setItem("language", command);
      axios.defaults.headers.common["language"] = command;

      switch (command) {
        case "tr":
          elLocale.use(langTR);
          dayjs.locale("tr");
          break;
        case "en":
          elLocale.use(langEN);
          dayjs.locale("en");
          break;
        case "ru":
          elLocale.use(langRU);
          dayjs.locale("ru");
          break;
        case "zh-tw":
          elLocale.use(langZHCH);
          dayjs.locale("zh-tw");
          break;
        case "zh":
          elLocale.use(langZHTW);
          dayjs.locale("zh");
          break;
        case "de":
          elLocale.use(langDE);
          dayjs.locale("de");

          break;
      }
      location.reload();
    },
  },
};
</script>